import { render, staticRenderFns } from "./Youngs.vue?vue&type=template&id=330b17ca&"
import script from "./Youngs.vue?vue&type=script&lang=js&"
export * from "./Youngs.vue?vue&type=script&lang=js&"
import style0 from "./Youngs.vue?vue&type=style&index=0&id=330b17ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports